import "./myWork.css";
import { useEffect, useState } from "react";

import LogoDdn from "./myWork_assets/logo-ddn.png";
import LogoCatur from "./myWork_assets/logo-catur.png";
import LogoAlma from "./myWork_assets/logo-alma.png";

import LogoVhesa from "./myWork_assets/logo-vhesa.png";
import LogoBullion from "./myWork_assets/logo-bullion.png";
import LogoLeva from "./myWork_assets/logo-leva.png";
import AOS from "aos";
import "aos/dist/aos.css";

export default function MyWork() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 100,
    });
  }, []);

  return (
    <div>
      <svg
        style={{ visibility: "hidden", position: "absolute" }}
        width="0"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <defs>
          <filter id="round">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>

      <div className="row">
        <div
          className="col-sm-12 col-md-12 col-lg-4 mb-5 d-flex justify-content-center"
          style={{ position: "relative" }}
        >
          <div className="bgWork w-100">
            <div className="hexagon"></div>
            <div className="hexagon2"></div>
            <div className="hexagon3"></div>
          </div>

          <div className="cardMw rounded">
            <div className="wrapper rounded">
              <div className="cover-image rounded">
                <div className="inner-mw rounded d-flex flex-column align-items-center justify-content-start p-3">
                  <h5 className=" mb-1">Web Application</h5>
                  <p className=" desc-mw mb-2">Fullstack</p>

                  <hr
                    className="m-0"
                    style={{
                      border: "solid 1px black",
                      width: "100%",
                      opacity: "10%",
                    }}
                  />
                  <p className=" desc-mw mt-2 mb-1 text-center px-2">
                    Dynamic is an e-commerce platform that sells coffee that
                    focuses on product authenticity. <br /> There is also an
                    admin dashboard with various roles{" "}
                  </p>
                  <div className="d-flex w-100 mt-auto justify-content-center">
                    <p className=" mb-0 desc-mw mx-1">#React</p>
                    <p className=" mb-0 desc-mw mx-1">#Express</p>
                    <p className=" mb-0 desc-mw mx-1">#MySql</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="title mb-2 text-center">DYINAMIC</p>
            <img src={LogoDdn} className="character" />
          </div>
        </div>
        <div
          className="col-sm-12 col-md-12 col-lg-4 mb-5 d-flex justify-content-center"
          style={{ position: "relative" }}
        >
          <div className="cardMw rounded">
            <div className="wrapper rounded">
              <div className="cover-image rounded">
                <div className="inner-mw rounded d-flex flex-column align-items-center justify-content-start p-3">
                  <h5 className=" mb-1">Web Company Profile</h5>
                  <p className=" desc-mw mb-2">Frontend</p>

                  <hr
                    className="m-0"
                    style={{
                      border: "solid 1px black",
                      width: "100%",
                      opacity: "10%",
                    }}
                  />
                  <p className=" desc-mw mt-2 mb-1 text-center px-2">
                    Catur Kartika Jaya is a company that sells fabric materials
                    and related components{" "}
                  </p>
                  <div className="d-flex w-100 mt-auto justify-content-center">
                    <p className=" mb-0 desc-mw mx-1">#React</p>
                    <p className=" mb-0 desc-mw mx-1">#Bootstrap</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="title mb-2 text-center">CATUR KARTIKA JAYA</p>
            <img src={LogoCatur} className="character" />
          </div>
        </div>
        <div
          className="col-sm-12 col-md-12 col-lg-4 mb-5 d-flex justify-content-center"
          style={{ position: "relative" }}
        >
          <div className="bgWork w-100">
            <div className="hexagon4"></div>
            <div className="hexagon5"></div>
            <div className="hexagon6"></div>
          </div>
          <div className="cardMw rounded">
            <div className="wrapper rounded">
              <div className="cover-image rounded">
                <div className="inner-mw rounded d-flex flex-column align-items-center justify-content-start p-3">
                  <h5 className=" mb-1">Web Company Profile</h5>
                  <p className=" desc-mw mb-2">Frontend</p>

                  <hr
                    className="m-0"
                    style={{
                      border: "solid 1px black",
                      width: "100%",
                      opacity: "10%",
                    }}
                  />
                  <p className=" desc-mw mt-2 mb-1 text-center px-2">
                    Alma Rezeki is a company that sells surfing equipment,
                    diving equipment and related components{" "}
                  </p>
                  <div className="d-flex w-100 mt-auto justify-content-center">
                    <p className=" mb-0 desc-mw mx-1">#React</p>
                    <p className=" mb-0 desc-mw mx-1">#Bootstrap</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="title mb-2 text-center">ALMA REZEKI</p>
            <img src={LogoAlma} className="character" />
          </div>
        </div>
      </div>

      <svg
        style={{ visibility: "hidden", position: "absolute" }}
        width="0"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <defs>
          <filter id="round">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>

      <div className="row">
        <div
          className="col-sm-12 col-md-12 col-lg-4 mb-5 d-flex justify-content-center"
          style={{ position: "relative" }}
        >
          <div className="bgWork w-100">
            <div className="hexagon"></div>
            <div className="hexagon2"></div>
            <div className="hexagon3"></div>
          </div>

          <div className="cardMw rounded">
            <div className="wrapper rounded">
              <div className="cover-image rounded">
                <div className="inner-mw rounded d-flex flex-column align-items-center justify-content-start p-3">
                  <h5 className=" mb-1">Web Application</h5>
                  <p className=" desc-mw mb-2">Fullstack</p>

                  <hr
                    className="m-0"
                    style={{
                      border: "solid 1px black",
                      width: "100%",
                      opacity: "10%",
                    }}
                  />
                  <p className=" desc-mw mt-2 mb-1 text-center px-2">
                    Vhesa is an e-commerce platform with digital invitation
                    products and printed invitations. <br /> There is also an
                    admin dashboard for approvals and data collection{" "}
                  </p>
                  <div className="d-flex w-100 mt-auto justify-content-center">
                    <p className=" mb-0 desc-mw mx-1">#React</p>
                    <p className=" mb-0 desc-mw mx-1">#Laravel</p>
                    <p className=" mb-0 desc-mw mx-1">#MySql</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="title mb-2 text-center">VHESA</p>
            <img src={LogoVhesa} className="character" />
          </div>
        </div>
        <div
          className="col-sm-12 col-md-12 col-lg-4 mb-5 d-flex justify-content-center"
          style={{ position: "relative" }}
        >
          <div className="cardMw rounded">
            <div className="wrapper rounded">
              <div className="cover-image rounded">
                <div className="inner-mw rounded d-flex flex-column align-items-center justify-content-start p-3">
                  <h5 className=" mb-1">Web & App Application</h5>
                  <p className=" desc-mw mb-2">Frontend</p>

                  <hr
                    className="m-0"
                    style={{
                      border: "solid 1px black",
                      width: "100%",
                      opacity: "10%",
                    }}
                  />
                  <p className=" desc-mw mt-2 mb-1 text-center px-2">
                    Bullion is a platform that provides a crypto wallet and
                    exchanges crypto assets into precious metals
                  </p>
                  <div className="d-flex w-100 mt-auto justify-content-center">
                    <p className=" mb-0 desc-mw mx-1">#React</p>
                    <p className=" mb-0 desc-mw mx-1">#Express</p>
                    <p className=" mb-0 desc-mw mx-1">#MySql</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="title mb-2 text-center">BULLION</p>
            <img src={LogoBullion} className="character" />
          </div>
        </div>
        <div
          className="col-sm-12 col-md-12 col-lg-4 mb-5 d-flex justify-content-center"
          style={{ position: "relative" }}
        >
          <div className="bgWork w-100">
            <div className="hexagon4"></div>
            <div className="hexagon5"></div>
            <div className="hexagon6"></div>
          </div>
          <div className="cardMw rounded">
            <div className="wrapper rounded">
              <div className="cover-image rounded">
                <div className="inner-mw rounded d-flex flex-column align-items-center justify-content-start p-3">
                  <h5 className=" mb-1">Web & App Application</h5>
                  <p className=" desc-mw mb-2">Frontend</p>

                  <hr
                    className="m-0"
                    style={{
                      border: "solid 1px black",
                      width: "100%",
                      opacity: "10%",
                    }}
                  />
                  <p className=" desc-mw mt-2 mb-1 text-center px-2">
                    Levabit is an e-commerce platform for selling advertising
                    services, besides that it also has a crypto wallet feature{" "}
                  </p>
                  <div className="d-flex w-100 mt-auto justify-content-center">
                    <p className=" mb-0 desc-mw mx-1">#Flutter</p>
                    <p className=" mb-0 desc-mw mx-1">#Express</p>
                    <p className=" mb-0 desc-mw mx-1">#MySql</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="title mb-2 text-center">LEVABIT</p>
            <img src={LogoLeva} className="character" />
          </div>
        </div>
      </div>
    </div>
  );
}
